import React, { useEffect } from 'react';
import R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';

import {
  Switch,
  Route,
  useRouteMatch
} from 'react-router-dom';

import { push } from 'connected-react-router';

import SurveyNav from '_organisms/SurveyNav';

import Section from 'react-bulma-companion/lib/Section';
import Container from 'react-bulma-companion/lib/Container';
import Box from 'react-bulma-companion/lib/Box';

import AdminAuth from './AdminAuth';
import PhoneAuth from './PhoneAuth';

export default function Auth() {
  const dispatch = useDispatch();
  let { path, url } = useRouteMatch();

  const { user } = useSelector(R.pick(['user']));

  useEffect(() => {
    if (!R.isEmpty(user)) {
      dispatch(push('/settings'));
    }
  }, []);

  return (
    <Section>
      <Container>
        <Box className="survey-box">
          <SurveyNav backwards={() => { }} back={false} />
          <Switch>
            <Route exact path={`${path}/email`} component={AdminAuth} />
            <Route exact path={`${path}/admin`} component={AdminAuth} />
            <Route exact path={`${path}/`} component={PhoneAuth} />
          </Switch>
        </Box>
      </Container>
    </Section>
  );
}